import { NameValue } from '../models/name-value';

export const LOADED_STATUSES: NameValue[] = [
    { name: 'Empty', value: 'E' },
    { name: 'Loaded', value: 'L' }
];
